import { FormLabel, Stack } from '@mui/joy';
import { Plus } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { IPartNoteForm } from 'bom/components';
import { IElement } from 'bom/types';
import { IManagedNote, Notes } from 'core/components';
import { INote } from 'core/types';
import { AddNoteButton } from 'jobs/components/JobDetails';
import { IJobPart } from 'jobs/types';
import { IPart } from 'parts/types';

interface IProps {
  jobId: number;
  jobPart?: IJobPart;
  element?: IElement;
  notesValue: IManagedNote[];
  onDeleteNote: (note: Partial<INote>) => Promise<void>;
  onEditNote: (data: Partial<INote>) => Promise<{ success: boolean }>;
  onAddNote: (() => (data: IPartNoteForm) => Promise<{ success: boolean } | void>) | null;
  isEdit: boolean;
  partValue: Partial<IPart>;
}

export const NotesSection = ({
  jobId,
  jobPart,
  element,
  notesValue,
  onDeleteNote,
  onEditNote,
  onAddNote,
  isEdit,
  partValue,
}: IProps) => {
  const { t } = useTranslation();

  if (!isEdit || !partValue) {
    return null;
  }

  return (
    <Stack gap={0.5}>
      {notesValue?.length > 0 && (
        <FormLabel>{`${t('labelNotes')} (${notesValue.length})`}</FormLabel>
      )}

      <Notes
        notes={notesValue}
        noteProps={{
          onDeleteNote,
          onSubmitEditNote: onEditNote,
        }}
        maxItems={2}
      />

      <AddNoteButton
        jobId={jobPart?.bomId || jobId}
        jobPart={jobPart}
        element={element}
        onSubmit={!isEdit ? onAddNote : undefined}
        level={1}
        buttonProps={{
          startDecorator: <Plus />,
          sx: { width: 'fit-content' },
        }}
      />
    </Stack>
  );
};
